import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomCard from "../components/CustomCard";
import { apiUrl } from "../config/api";
import { getCurrentLang } from "../components/LangSelector";
import useSEO from "../hooks/useSEO";

const FavoritesPage = () => {
  useSEO({ title: 'Избранное | JobMD' });
  const [favorites, setFavorites] = useState([]);
  const navigate = useNavigate();

  const loadFavorites = () => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;
    const lang = getCurrentLang();

    fetch(`${apiUrl("favorites.php")}?user=${userId}&lang=${lang}`)
      .then(res => res.json())
      .then(data => setFavorites(data));
  };

  useEffect(() => {
    loadFavorites();
    window.addEventListener('app:langChange', loadFavorites);
    return () => window.removeEventListener('app:langChange', loadFavorites);
  }, []);

  return (
    <Box maxWidth="1200px" mx="auto" mt={4}>

      {/* HEADER */}
      <Box mb={3}>
        <Typography variant="h4" fontWeight="bold">
          Избранные вакансии
        </Typography>

        <Typography color="text.secondary">
          Ваши сохранённые вакансии
        </Typography>
      </Box>

      {/* CONTENT */}
      {favorites.length > 0 ? (
        <Grid container spacing={3}>
          {favorites.map((job) => (
            <Grid item xs={12} sm={6} md={4} key={job.id}>
              <CustomCard
                id={job.id}
                image={job.image_url}
                title={job.title}
                description={job.description}
                salary={job.salary}
                city={job.location || job.city}
                dateAdded={job.created_at}
                category={job.category}
                onMoreClick={() => navigate(`/job/${job.id}`)}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Paper
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: 3,
          }}
        >
          <Typography color="text.secondary">
            Нет избранных вакансий
          </Typography>
        </Paper>
      )}

    </Box>
  );
};

export default FavoritesPage;